import {SolicitudActionTypes, SET_SOLICITUD, SET_SOLICITUD_COPIA} from "../types/solicitudActionType";
import {Solicitud} from "../../entities/solicitudes/Solicitud";

export function setSolicitud (solicitud: Solicitud): SolicitudActionTypes {
    return {
        type: SET_SOLICITUD,
        solicitud: solicitud
    }
}

export function setSolicitudCopia (solicitud: Solicitud): SolicitudActionTypes {
    return {
        type: SET_SOLICITUD_COPIA,
        solicitud: solicitud
    }
}
